import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  courses: 'Courses',
  inThisCourse: 'In this course',
  lessons: 'Lessons',
  invalidFolder:
    'This will not be visible to learners as there is no actual lesson content within',
  invalidLesson:
    'This lesson not be visible to learners as there is no actual content within',
  coursePreview: 'Course preview',
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'Lesson' : 'Lessons'}`,
  publishCourse: 'Publish course',
  republishCourse: 'Republish course',
  publishingCourse: 'Course is publishing',
  datePublished: 'Date published',
  publishSuccessful: 'Course publish started successfully',
  republishSuccessful: 'Course republish started successfully',
  contactAdmin: 'Contact your admin to publish this course',
  minApprox: 'min. approx.',
  microreelChip: 'Microreel',
  addLessonToPublish: 'Add at least one lesson to publish this course',
};

const welsh = {
  courses: 'Cyrsiau',
  inThisCourse: 'Yn y cwrs hwn',
  lessons: 'Gwersi',
  invalidFolder:
    'Nid fydd hyn yn weladwy i ddysgwyr gan nad oes unrhyw gynnwys gwersi gwirioneddol o fewn',
  invalidLesson:
    'This lesson not be visible to learners as there is no actual content within',
  coursePreview: 'Gweddol y cwrs',
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'Gwers' : 'Gwersi'}`,
  publishCourse: "Cyhoeddi'r cwrs",
  minApprox: 'isaf. Amcangyfrif.',
  republishCourse: "Ailgyhoeddi'r cwrs",
  publishingCourse: "Mae'r cwrs yn cael ei gyhoeddi",
  datePublished: 'Dyddiad cyhoeddi',
  publishSuccessful: "Mae cyhoeddi'r cwrs wedi dechrau'n llwyddiannus",
  republishSuccessful: "Mae ailgyhoeddi'r cwrs wedi dechrau'n llwyddiannus",
  microreelChip: 'Microreel',
  addLessonToPublish: "Ychwanegwch o leiaf un wers i gyhoeddi'r cwrs hwn",
};

export const coursePreviewText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
